/**
 * @desc 一键入库
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanMasterOneClickInboundDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/oneClickInbound`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
